/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OwnerApiResponse } from '../models/OwnerApiResponse';
import type { OwnerCreateDto } from '../models/OwnerCreateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OwnerService {

    /**
     * @param requestBody
     * @returns OwnerApiResponse Success
     * @throws ApiError
     */
    public static postApiV1Owners(
        requestBody?: OwnerCreateDto,
    ): CancelablePromise<OwnerApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/owners',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
